var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_11592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4301 29.7301H33.6101C31.9754 29.7301 30.6501 31.0553 30.6501 32.6901V55.5101C30.6501 57.1449 31.9754 58.4701 33.6101 58.4701H56.4301C58.0649 58.4701 59.3901 57.1449 59.3901 55.5101V32.6901C59.3901 31.0553 58.0649 29.7301 56.4301 29.7301Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6501 48.29H23.5701C21.9301 48.29 20.6101 46.97 20.6101 45.33V22.51C20.6101 20.87 21.9301 19.55 23.5701 19.55H46.3901C48.0301 19.55 49.3501 20.87 49.3501 22.51V29.57",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4101 45.13C46.7701 43.31 43.2701 43.31 40.6301 45.13L30.6501 51.99V58.51H59.3901V51.99L49.4101 45.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8301 40.6901C39.4869 40.6901 40.8301 39.3469 40.8301 37.6901C40.8301 36.0332 39.4869 34.6901 37.8301 34.6901C36.1732 34.6901 34.8301 36.0332 34.8301 37.6901C34.8301 39.3469 36.1732 40.6901 37.8301 40.6901Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_11592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.78,
    height: 42.9,
    fill: "white",
    transform: "translate(18.6101 17.55)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.49f28908396a82c75e2bd018285ecc31.svg";
export { ForwardRef as ReactComponent };